<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    import {computed, onMounted} from '@vue/composition-api';
    import {DateTime} from "luxon";
    import XLSX from 'xlsx';
    import eConfig from "../../evention-config.js"

    export default {
        name: 'EventReportAgendaGroup',
        setup(props, {root}) {
            const {Event, EventGuest, EventAgenda, EventAgendaGroup} = root.$FeathersVuex.api;

            const isTemplate = computed(() => root.$route.params.isTemplate);
            const eventId = computed(() => root.$route.params.eventId);
            const dbColMapping = eConfig.guest.dbColMapping;
            
            const exportGuest = async () => {
                const event = await Event.get(eventId.value);
                const {data: eventGuestArr} = await EventGuest.find({
                    query: {
                        eventId: eventId.value,
                    },
                });
                const eventGuestIdMap = {}
                for (let i = 0; i < eventGuestArr.length; i++) {
                    const eg = eventGuestArr[i]
                    eventGuestIdMap[eg.id] = eventGuestArr[i]
                }

                const {data: eventAgendaArr} = await EventAgenda.find({
                    query: {
                        eventId: eventId.value,
                        $select: [
                            'id', 'title', 'order', 'title_tc', 'title_sc', 'address', 'address_tc', 'address_sc'
                        ],
                    },
                });
                const eventAgendaIdMap = {}
                for (let i = 0; i < eventAgendaArr.length; i++) {
                    const ea = eventAgendaArr[i]
                    eventAgendaIdMap[ea.id] = eventAgendaArr[i]
                }

                const eventAgendaIdList = eventAgendaArr.map((e) => e.id)
                const {data: eventAgendaGroupArr} = await EventAgendaGroup.find({
                    query: {
                        fAgendaId: {
                            $in: eventAgendaIdList,
                        },
                        $sort: {
                            fAgendaId: -1,
                        },
                        $select: [
                            'eventGuestId', 'fAgendaId', 
                        ]
                    },
                });

                const nestedEAGmap = {}
                for (let i = 0; i < eventAgendaGroupArr.length; i++) {
                    const eag = eventAgendaGroupArr[i]
                    if (!nestedEAGmap[eag.eventGuestId]) {
                        nestedEAGmap[eag.eventGuestId] = {}
                    }
                    
                    nestedEAGmap[eag.eventGuestId][eag.fAgendaId] = eventAgendaGroupArr[i]
                }

                // console.log(eventGuestIdMap, eventAgendaIdMap)
                // console.log(eventGuestArr, eventAgendaArr)
                // console.log(eventAgendaGroupArr)
                // console.log(nestedEAGmap)

                const result = []
                for (let i = 0; i < eventGuestArr.length; i++) {
                    const eg = eventGuestArr[i]

                    for (let j = 0; j < eventAgendaIdList.length; j++) {
                        const agendaId = eventAgendaIdList[j]
                        const agendaExcelField = `Agenda ${eventAgendaIdMap[agendaId]['order']}: ${eventAgendaIdMap[agendaId]['title']}`
                        if (nestedEAGmap[eg.id] && nestedEAGmap[eg.id][agendaId]) {
                            eg[agendaExcelField] = 1
                        } else {
                            eg[agendaExcelField] = 0
                        }
                    }

                    result.push(eg)
                }
                // console.log(result)
                
                let excelData = [];

                excelData = result;
                const ws = XLSX.utils.json_to_sheet(excelData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, event.name);
                XLSX.writeFile(wb, 'agenda_group_guest_'+eventId.value+'_'+DateTime.local().toFormat('yyyyMMdd_HHmmss')+'.xlsx');
                
                root.$router.go(-1);
            }
            
            onMounted(() => {
                exportGuest();
            });

            return {
            }
        },
    }
</script>
